import React from 'react';

const AppSideBar = ({ children }) => {
  return <div>{children}</div>;
};

export default AppSideBar;
